import { useState } from "react";
import Button from "../../components/common/Button";
import Banner from "../../components/Landing/Banner";
import Objectives from "../../components/Landing/Objectives";
import RequiredDocuments from "../../components/Landing/RequiredDocuments";
import Section from "../../components/Landing/Section";
import YojanaSections from "../../components/Landing/YojanaSections";
import { MSY_WEBSITE_URL } from "../../config/apiConfig";
import {
  deenDayalEligibility,
  deenDayalRequiredDocuments,
  deenDayalYojanaObjectives,
  deenDayalYojanaSections,
  yojanaBannerItems,
} from "../../config/homePageUtils";
import HomeLayout from "./HomeLayout";
import { useLanguage } from "../../components/LanguageProvider/LanguageProvider";

const DeenDayalYojana = () => {
  const { image, title, description, overview } =
    yojanaBannerItems.deenDayalYojana;
  const [activeSection, setActiveSection] = useState("overview");
  const { language } = useLanguage();

  return (
    <HomeLayout>
      <Banner
        image={image}
        title={title}
        description={description}
        buttonUrl={MSY_WEBSITE_URL}
        language={language}
      />

      <YojanaSections
        options={deenDayalYojanaSections}
        activeSection={activeSection}
        setActiveSection={setActiveSection}
        language={language}
      >
        {/* Overview Section */}
        {activeSection === "overview" && (
          <Section
            id="overview"
            title={language ? "संक्षिप्त विवरण" : "Overview"}
            openByDefault={true}
            language={language}
          >
            <p>{language ? overview.hi : overview.en}</p>
          </Section>
        )}

        {activeSection === "objectives" && (
          <Objectives data={deenDayalYojanaObjectives} language={language} />
        )}

        {/* Eligibility Section */}
        {activeSection === "eligibility" && (
          <Section
            id="eligibility"
            title={language ? "योग्यता" : "Eligibility"}
          >
            <ul className="list-unstyled space-y-3">
              {deenDayalEligibility.map((item, idx) => (
                <li key={idx} className="d-flex align-items-start">
                  <span className="text-[#018f9b] me-2 mt-1">●</span>
                  <span>{language ? item.hi : item.en}</span>
                </li>
              ))}
            </ul>
          </Section>
        )}

        {/* Application Submission Section */}
        {activeSection === "application-submission" && (
          <Section
            id="application-submission"
            title={language ? "आवेदन जमा करना" : "Application Submission"}
          >
            <p>
              {language
                ? "दीन दयाल उपाध्याय गृह आवास योजना के लिए ऑनलाइन आवेदन (msy.uk.gov.in) पर जमा किए जाने चाहिए।"
                : "Online applications for the Deen Dayal Upadhyay Housing Scheme (Home-Stay) must be submitted at (msy.uk.gov.in.)"}
            </p>
          </Section>
        )}

        {/* Required Documents — NOW COLLAPSIBLE */}
        {activeSection === "required-documents" && (
          <Section
            id="required-documents"
            title={language ? "आवश्यक दस्तावेज" : "Required Documents"}
            spaceY4Needed={false}
          >
            <RequiredDocuments
              documents={deenDayalRequiredDocuments}
              language={language}
            />
          </Section>
        )}
      </YojanaSections>

      {/* Apply Button — ALWAYS VISIBLE */}
      <section className="px-4 py-10 md:px-20 lg:px-32">
        <div className="max-w-7xl mx-auto px-0">
          <Button
            className="inline-flex items-center bg-[#018f9b] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#3e8722] transition"
            onClick={() =>
              window.open(MSY_WEBSITE_URL, "_blank", "noopener,noreferrer")
            }
          >
            {language ? "अभी अप्लाई करें" : "Apply Now/ Login"} →
          </Button>
        </div>
      </section>
    </HomeLayout>
  );
};

export default DeenDayalYojana;
